import PropTypes from 'prop-types';
import React from 'react';
import {
  ROW_TYPE_ONE_PRIME_CARD,
  ROW_TYPE_THREE_PRIME_CARDS,
  ROW_TYPE_THREE_STANDARD_CARDS,
  ROW_TYPE_TWO_STANDARD_CARDS
} from '../../constants';
import Row from '../row/row';
import {get, flatten, cloneDeep, map, chunk} from 'lodash';
import { getModuleAdSizes } from '../../utils/ads/sizes';

const formatPrimeCard = (card) => ({
  cards: [card],
  key: card.id,
  rowID: 0,
  indexWithinModule: 0,
  type: ROW_TYPE_ONE_PRIME_CARD,
  tabletAdPosition: null
});

const formatStandardRows = (row) => {
  const chunked = chunk(row.cards, 2);

  return map(chunked, (twoCards, index) => {
    return {
      cards: twoCards,
      key: twoCards[0].id + index,
      rowID: row.rowID,
      indexWithinModule: row.indexWithinModule,
      type: ROW_TYPE_TWO_STANDARD_CARDS,
      tabletAdPosition: row.tabletAdPosition
        ? row.tabletAdPosition
        : null
    };
  });
};

const reformatForTablet = (rows) => {
  const formattedRows = [];
  let leftoverCard;

  const rowsCopy = cloneDeep(rows);
  const cardToBePrime = rowsCopy[0].cards.shift();
  const primeCard = formatPrimeCard(cardToBePrime);

  formattedRows.push(primeCard);

  rowsCopy.forEach((row) => {
    if (leftoverCard) {
      const secondCard = row.cards.shift();
      // Some rows will have duplicate IDs and indexWithinModules - should be OK
      const newRow = {
        cards: [leftoverCard, secondCard],
        rowID: row.rowID,
        indexWithinModule: row.indexWithinModule
      };
      formattedRows.push(formatStandardRows(newRow));
      leftoverCard = null;
    }

    if (row.cards.length % 2 !== 0) {
      leftoverCard = row.cards.pop();
    }

    formattedRows.push(formatStandardRows(row));
  });

  return flatten(formattedRows);
};

// We want to format for tablet if ALL rows in the module are either Prime rows or Standard rows.
const shouldPeformTabletReformatting = (rows) => {
  for (let i = 0; i < rows.length; i++) {
    if (rows[i].type !== ROW_TYPE_THREE_PRIME_CARDS && rows[i].type !== ROW_TYPE_THREE_STANDARD_CARDS) {
      return false;
    }
  }

  return true;
};

const TabletContentModule = ({
  adsState,
  archivesState,
  breakpoint,
  id,
  page_id,
  page_type,
  rows,
  title,
  type,
  channelCampaignBrandingImage,
  channelSubtitle
}) => (
  <div>
    {
      rows.length > 0 &&
      map((shouldPeformTabletReformatting(rows)
        ? reformatForTablet(rows)
        : rows
      ), row => (
        <Row {...row}
          key={get(row, 'cards[0].id')}
          adPosition={row[`${breakpoint}AdPosition`]}
          adSizes={getModuleAdSizes(type, breakpoint)}
          adsState={adsState}
          archivesState={archivesState}
          breakpoint={breakpoint}
          moduleID={id}
          moduleTitle={title}
          moduleType={type}
          page_id={page_id}
          page_type={page_type}
          type={row.type}
          channelCampaignBrandingImage={channelCampaignBrandingImage}
          channelSubtitle={channelSubtitle}
        />
      ))
    }
  </div>
);

TabletContentModule.propTypes = {
  adsState: PropTypes.object.isRequired,
  archivesState: PropTypes.object,
  breakpoint: PropTypes.string,
  id: PropTypes.number.isRequired,
  page_id: PropTypes.number,
  page_type: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    rowID: PropTypes.number,
    indexWithinModule: PropTypes.number,
    moduleTitle: PropTypes.string,
    cards: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number }))
  })).isRequired,
  title: PropTypes.string,
  type: PropTypes.string,
  channelCampaignBrandingImage: PropTypes.string,
  channelSubtitle: PropTypes.string
};

TabletContentModule.defaultProps = {
  adsState: {},
  rows: []
};

export default TabletContentModule;
